import React from 'react';

import type {Origin} from '../../../generated/types';
import {EntitySeo} from '../../../lib/seo';
import {buildUrl} from '../../../lib/routes';
import {originDescription} from './origin-seo-text';

export const OriginSeo: React.FC<{origin: Origin}> = ({origin}) => (
	<EntitySeo
		entity={origin}
		section="origins"
		kind="предыстория"
		description={originDescription(origin)}
		path={buildUrl('origin', {id: origin.id})}
		og={{kind: 'origin'}}
	/>
);
